<template>
  <div :id="`overlay-wrapper${alternative ? '-alt' : ''}`">
    <div
      id="legend-filters"
      class="d-flex legend-filters"
    >
      <Button
        type="button"
        :label="$t('processes.map.legend')"
        class="align-self-end mr-2 p-button-sm"
        :disabled="disabled || !municipalityCode || !showMapItems"
        @click="handleLegend"
      />
      <div class="d-flex flex-fill align-items-center">
        <div
          v-for="(group, key) in filterItems"
          :key="key"
          class="active-category"
        >
          <!-- <span
            v-if="group.selectedValues.length"
            class="mr-1 tags-title"
          >
            {{ group.title }}
          </span> -->
          <img
            v-for="(value, index) in group.selectedValues"
            :key="index"
            width="15"
            class="mr-2 tag"
            :src="image({ name: value.icon })"
            @click="removeSelectedValue({ value, key })"
          >
        </div>
      </div>
    </div>
    <OverlayPanel
      ref="op"
      :append-to="`overlay-wrapper${alternative ? '-alt' : ''}`"
      class="legend-overlay flex-fill"
    >
      <div
        v-for="(group, key) in filterItems"
        :key="key"
        class="legend-category"
      >
        <div v-if="group.visible">
          <strong>{{ group.title }}</strong>
          <div
            v-if="!group.activeItems.length"
            class="mt-2 small"
          >
            {{ $t('Process.noRecordsFound', { type: group.title.toLowerCase() }) }}
          </div>
          <Listbox
            v-model="group.selectedValues"
            :options="group.activeItems"
            :multiple="true"
            option-label="name"
          >
            <template #option="slotProps">
              <img
                v-if="slotProps.option.icon"
                width="20"
                :src="image({ name: slotProps.option.icon })"
                class="mr-1"
              >
              {{ setOptionLabel(slotProps.option, key) }}
            </template>
          </Listbox>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Button from 'primevue/button'
import OverlayPanel from 'primevue/overlaypanel'
import Listbox from 'primevue/listbox'
import Tooltip from 'primevue/tooltip'
import { image } from '@/helpers/assets'

export default {
  name: 'MapFilterItems',
  components: {
    Button,
    OverlayPanel,
    Listbox,
  },
  directives: {
    'tooltip': Tooltip,
  },
  props: {
    municipalityCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showMapItems: {
      type: Boolean,
      default: true
    },
    alternative: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      image: image,
      filterItems: {
        chargingpoints: {
          title: this.$i18n.t('ProfileCard.featureAccess.chargingpoints'),
          visible: true,
          items: [
            { type: 'suggestion', name: 'Voorgesteld', icon: 'chargingpoint-suggestion' },
            { type: 'definitive', name: 'Gevalideerd', icon: 'chargingpoint-definitive' },
            { type: 'in-progress', name: 'In voorbereiding', icon: 'chargingpoint-in-progress' },
            { type: 'rejected', name: 'Afgekeurd', icon: 'chargingpoint-rejected' },
            { type: 'realized', name: 'Gerealiseerd', icon: 'chargingpoint-realized' },
            { type: 'realized-proprietary', name: 'Gerealiseerd (eigen)', icon: 'chargingpoint-realized-proprietary' },
            { type: 'suggestion-private', name: 'Voorgesteld privaat', icon: 'chargingpoint-suggestion-private' },
            { type: 'definitive-private', name: 'Gevalideerd privaat', icon: 'chargingpoint-definitive-private' },
            { type: 'in-progress-private', name: 'In voorbereiding privaat', icon: 'chargingpoint-in-progress-private' },
            { type: 'rejected-private', name: 'Afgekeurd privaat', icon: 'chargingpoint-rejected-private' },
            { type: 'realized-private', name: 'Gerealiseerd privaat', icon: 'chargingpoint-realized-private' },
            { type: 'realized-private-proprietary', name: 'Gerealiseerd privaat (eigen)', icon: 'chargingpoint-realized-private-proprietary' },
            { type: 'isWorkflowAltLocation', name: 'Alternatieve locatie', prop: 'isWorkflowAltLocation', icon: 'chargingpoint-alternative' },
            { type: 'charging-hub-suggestion', name: 'Voorgesteld laadplein', icon: 'chargingpoint-suggestion' },
            { type: 'charging-hub-definitive', name: 'Gevalideerd laadplein', icon: 'chargingpoint-definitive' },
            { type: 'charging-hub-in-progress', name: 'Laadplein in voorbereiding', icon: 'chargingpoint-in-progress' },
            { type: 'charging-hub-rejected', name: 'Afgekeurd laadplein', icon: 'chargingpoint-rejected' },
            { type: 'charging-hub-realized', name: 'Gerealiseerd laadplein', icon: 'chargingpoint-realized' },
            { type: 'fastcharger-suggestion', name: 'Voorgesteld snellader', icon: 'chargingpoint-fastcharger-suggestion' },
            { type: 'fastcharger-definitive', name: 'Gevalideerd snellader', icon: 'chargingpoint-fastcharger-definitive' },
            { type: 'fastcharger-in-progress', name: 'Snellader in voorbereiding', icon: 'chargingpoint-fastcharger-in-progress' },
            { type: 'fastcharger-rejected', name: 'Afgekeurd snellader', icon: 'chargingpoint-fastcharger-rejected' },
            { type: 'fastcharger-realized', name: 'Gerealiseerd snellader', icon: 'chargingpoint-fastcharger-realized' }
          ],
          activeItems: [],
          selectedValues: [],
        },
        realisations: {
          title: this.$i18n.t('navbar.processes'),
          visible: this.showMapItems,
          items: [
            { type: 'active', name: this.$i18n.t('processStatus.active'), icon: 'realisation' },
            { type: 'onhold', name: this.$i18n.t('processStatus.onhold'), icon: 'realisation-onhold' },
            { type: 'cancelled', name: this.$i18n.t('processStatus.cancelled'), icon: 'realisation-cancelled' },
            { type: 'completed', name: this.$i18n.t('processStatus.completed'), icon: 'realisation-completed' },
          ],
          activeItems: [],
          selectedValues: [],
        },
        requests: {
          title: this.$i18n.t('navbar.requests'),
          visible: this.showMapItems,
          items: [
            { type: 'completed', name: this.$i18n.t(`mapLegend.${'request-completed'}`), icon: 'request-completed' }, // Create icon for this
            { type: 'open', name: this.$i18n.t(`mapLegend.${'request-open'}`), icon: 'request-open' },
            { type: 'accepted', name: this.$i18n.t(`mapLegend.${'request-accepted'}`), icon: 'request-accepted' },
            { type: 'connectedToSelectedRP', name: this.$i18n.t(`mapLegend.${'request-selected'}`), icon: 'request-selected', static: true },
            { type: 'connected', name: this.$i18n.t(`mapLegend.${'request-connected'}`), icon: 'request-connected' },
          ],
          activeItems: [],
          selectedValues: [],
        },
      }
    }
  },

  computed: {
    ...mapGetters('chargingpoints', ['getActiveFilterItems', 'getSelectedFilterValues']),
    ...mapGetters('tenant', ['getChargingpointStatuses']),

    statusLabelsLocale () {
      const labels = {}
      this.getChargingpointStatuses.forEach(status => labels[status.value] = status.label[this.$i18n.locale])

      return labels
    }
  },

  watch: {
    filterItems: {
      deep: true,
      handler () {
        this.handleFilterItems()
      },
    },

    getActiveFilterItems: {
      deep: true,
      handler () {
        this.setActiveLegendItems()
        this.setSelectedFilterValues()
      },
    }
  },

  beforeDestroy () {
    this.$store.dispatch('chargingpoints/loadSelectedFilterValues', { filterValues: this.selectedFilterValues() })
  },

  methods: {
    // TODO: refactor filterItems.items => computed for reactivity //
    setOptionLabel (option, key) {
      return key === 'chargingpoints'
        ? this.statusLabelsLocale[option.type]
        : key === 'realisations'
          ? this.$i18n.t(`processStatus.${option.type}`)
          : this.$i18n.t(`mapLegend.${option.icon}`) // Requests
    },

    setActiveLegendItems () {
      Object.keys(this.getActiveFilterItems)
        .map(key => {
          this.filterItems[key].activeItems = this.filterItems[key].items
            .filter(item => this.getActiveFilterItems[key].some(k => k === item.type))
        })
    },

    setSelectedFilterValues () {
      Object.keys(this.getSelectedFilterValues)
        .map(key => {
          if (this.filterItems[key]) {
            this.filterItems[key].selectedValues = this.getSelectedFilterValues[key]
          }
        })
    },

    handleLegend (event) {
      this.$refs.op.toggle(event)
      this.$emit('panelOpened')
    },

    selectedFilterValues () {
      const filters = {}
      Object.keys(this.filterItems).map(filter => filters[filter] = this.filterItems[filter].selectedValues )
      filters.activeMunicipality = this.municipalityCode

      return filters
    },

    handleFilterItems () {
      if (JSON.stringify(this.getSelectedFilterValues) === JSON.stringify(this.selectedFilterValues())) return

      this.setActiveFilterItems()
    },

    resetSelectedFilters () {
      Object.keys(this.filterItems).map(filter => {
        this.filterItems[filter].selectedValues = []
      })
      this.handleFilterItems()
    },

    removeSelectedValue ({ value, key }) {
      const index = this.filterItems[key].selectedValues.findIndex(filter => filter.type === value.type)
      this.filterItems[key].selectedValues.splice(index, 1)

      this.setActiveFilterItems()
    },

    setActiveFilterItems () {
      const selectedValues = this.selectedFilterValues()

      this.$store.dispatch('realisations/filterRealisations', { filters: selectedValues })
      this.$store.dispatch('chargingpoints/filterChargingPoints', { filters: selectedValues })
      this.$store.dispatch('requests/filterRequests', { filters: selectedValues, selectedRealisation: this.$route.params.uuid })

      this.$store.dispatch('chargingpoints/loadSelectedFilterValues', { filterValues: selectedValues })
      this.$emit('filter')
    },
  },
}
</script>
<style lang="scss" scoped>
  ::v-deep {
    .p-multiselect {
      width: 100%;
    }
    .p-listbox {
      border: none;
      .p-listbox-list .p-listbox-item {
        padding: 0.3em;
        font-size: 13px;
        &.p-disabled {
          opacity: 1;
        }
      }
    }
  }
  .legend-filters {
    // padding: 0 0 1em 0;
    //background: #e9ecef;
    .tags-title {
      font-size: 12px;
    }
    .tag {
      cursor: pointer;
    }
    .active-category {
      &:first-child {
        flex: 0 1 40%;
      }
      flex: 0 1 30%;
    }
  }
  .legend-overlay {
    position: absolute;
    top: 2.6em !important;
    left: 0 !important;
    width: 100%;
    z-index: 3 !important;
    ::v-deep .p-overlaypanel-content {
      display: flex;
      justify-content: space-between;
    }
  }
  #overlay-wrapper {
    width: 100%;
    max-width: 500px;
  }
</style>
